import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phasesContainer", "phaseRow"]

  connect() {
    // Initialize phase counter from existing phases
    this.phaseCounter = this.phaseRowTargets.length
  }

  addPhase(event) {
    event.preventDefault()

    const newPhaseId = this.getNextPhaseId()
    const phaseRow = this.createPhaseRow(newPhaseId, "")

    this.phasesContainerTarget.insertAdjacentHTML('beforeend', phaseRow)
    this.phaseCounter++

    // Focus on the new phase name input
    const inputs = this.phasesContainerTarget.querySelectorAll('input[type="text"]')
    inputs[inputs.length - 1].focus()
  }

  removePhase(event) {
    event.preventDefault()

    const phaseRow = event.target.closest('[data-program-form-target="phaseRow"]')

    // Don't allow removing if it's the last phase
    if (this.phaseRowTargets.length <= 1) {
      alert("Programs must have at least one phase.")
      return
    }

    phaseRow.remove()
    this.reindexPhases()
  }

  movePhaseUp(event) {
    event.preventDefault()
    const phaseRow = event.target.closest('[data-program-form-target="phaseRow"]')
    const previousRow = phaseRow.previousElementSibling
    if (previousRow) {
      phaseRow.parentNode.insertBefore(phaseRow, previousRow)
      this.reindexPhases()
    }
  }

  movePhaseDown(event) {
    event.preventDefault()
    const phaseRow = event.target.closest('[data-program-form-target="phaseRow"]')
    const nextRow = phaseRow.nextElementSibling
    if (nextRow) {
      phaseRow.parentNode.insertBefore(nextRow, phaseRow)
      this.reindexPhases()
    }
  }

  reindexPhases() {
    this.phaseRowTargets.forEach((row, index) => {
      row.querySelectorAll('input').forEach(input => {
        input.name = input.name.replace(/phases\[\d+\]/, `phases[${index}]`)
      })
    })
  }

  getNextPhaseId() {
    // Find the highest phase ID currently in use
    const phaseIds = Array.from(this.phasesContainerTarget.querySelectorAll('input[name*="[id]"]'))
      .map(input => parseInt(input.value) || 0)

    return phaseIds.length > 0 ? Math.max(...phaseIds) + 1 : 1
  }

  createPhaseRow(phaseId, phaseName) {
    const index = this.phaseCounter

    return `
      <div class="flex gap-2 items-start" data-program-form-target="phaseRow">
        <div class="flex flex-col gap-0.5">
          <button type="button"
                  class="inline-flex items-center rounded bg-gray-100 p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
                  data-action="click->program-form#movePhaseUp"
                  title="Move up">
            <svg class="h-3 w-3" fill="none" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z" clip-rule="evenodd" fill="currentColor" />
            </svg>
          </button>
          <button type="button"
                  class="inline-flex items-center rounded bg-gray-100 p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
                  data-action="click->program-form#movePhaseDown"
                  title="Move down">
            <svg class="h-3 w-3" fill="none" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" fill="currentColor" />
            </svg>
          </button>
        </div>
        <input type="hidden" name="program[phases][${index}][id]" value="${phaseId}">
        <div class="flex-1">
          <input type="text"
                 name="program[phases][${index}][name]"
                 value="${phaseName}"
                 placeholder="Phase name"
                 class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                 required>
        </div>
        <button type="button"
                class="inline-flex items-center rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-700 hover:bg-red-100"
                data-action="click->program-form#removePhase">
          <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </button>
      </div>
    `
  }
}
